import TopContentFreeShipping from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/TopContentFreeShipping/TopContentFreeShipping';

export default TopContentFreeShipping;
